import { Card, CardContent, Typography, Grid } from "@mui/material";
import { AdditionalDetails } from "../../../../interfaces/DTO/mislaka_xml_insurence_models";
import { formatIsoDate, formatPercentage } from "../../../../utils/namesFormater";
import { formatAdditionalType } from "../../../../utils/pensionEnumFormatter";


interface AdditionalDetailsCardProps {
  detail: AdditionalDetails;
}
interface FieldDef<T> {
  field: keyof T;
  label: string;
  format?: (value: any) => string | number;
}


const additionalDetailsFieldDefs: FieldDef<AdditionalDetails>[] = [
  { field: 'additional_tariff', label: 'תעריף תוספת' },
  { field: 'additional_type', label: 'סוג תוספת', format: formatAdditionalType },
  { field: 'additional_rate', label: 'שיעור תוספת', format: formatPercentage },
  { field: 'additional_promil', label: 'פרומיל תוספת' },
  { field: 'additional_end_date', label: 'תום תקופת התוספת', format: formatIsoDate },
];



export const AdditionalDetailsCard: React.FC<AdditionalDetailsCardProps> = ({ detail }) => {
  return (
    <Card className="rounded-2xl shadow-md p-4">
      <CardContent>
        <Typography variant="h6" gutterBottom>
          פרטי תוספת
        </Typography>
        <Grid container spacing={2}>
          {additionalDetailsFieldDefs.map(({ field, label, format }) => {
            const value = detail[field];
            if (value == null || value === '') return null;
            const display = format ? format(value) : value;
            return (
              <Grid item xs={12} sm={6} key={field as string}>
                <strong>{label}:</strong> {display}
              </Grid>
            );
          })}
        </Grid>
      </CardContent>
    </Card>
  );
};
